// Subscribes to the shared playbackClock and returns wall time (epoch ms), ~once per second.
// When disabled, returns the mount-time Date.now() with no rAF subscription.

import { useEffect, useState } from 'react';
import { playbackClock } from '../services/playbackClock';

export function usePlaybackClock(enabled: boolean = true): number {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    if (!enabled) return;
    return playbackClock.subscribe(setNow);
  }, [enabled]);

  return now;
}
